import { render, staticRenderFns } from "./ConfiguracaoCalendarioAprovacao.vue?vue&type=template&id=0afdbd92&lang=html&"
import script from "./ConfiguracaoCalendarioAprovacao.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoCalendarioAprovacao.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoCalendarioAprovacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/configuracao/ConfiguracaoCalendarioAprovacao.vue
// module id = 1135
// module chunks = 28